enum OnboardingErrorCode {
  GenericError = 'GenericError',
  InvitationExpired = 'InvitationExpired',
  PasswordStrengthError = 'PasswordStrengthError',
}

export default OnboardingErrorCode;
